<div class="report-page">

  <!-- Section Header -->
  <div class="section-header">
    <h4>
      <span class="material-symbols-outlined"
        style="vertical-align:middle;font-size:1.1rem;margin-right:5px;">account_tree</span>
      Office Hierarchy Training Plan Summary
    </h4>
    <button class="signin" type="button" (click)="loadHierarchySummary()">
      <span class="material-symbols-outlined">refresh</span>
      Refresh Report
    </button>
  </div>

  <!-- Loading / Error States -->
  @if(isLoading()) {
  <div class="state-banner">Loading office hierarchy summary...</div>
  }
  @if(errorMessage()) {
  <div class="state-banner state-banner--error">{{ errorMessage() }}</div>
  }

  <!-- Summary Cards: Own Office + Sub Office -->
  @if(!isLoading()) {
  <div class="summary-cards-grid">

    <!-- Own Office Summary Card -->
    <fieldset>
      <legend>Own Office Plan Summary</legend>
      <div class="summary-card">
        <div class="summary-card-header">
          <h5 class="summary-card-title">
            <span class="dot"></span> Logged-In Office
          </h5>
          <span class="scope-badge">Own Office</span>
        </div>

        <div class="metrics-grid">
          <div class="metric-box">
            <span class="metric-label">Total Plans</span>
            <span class="metric-value">{{ ownOfficeSummary().totalPlans }}</span>
          </div>
          <div class="metric-box approved">
            <span class="metric-label">Approved</span>
            <span class="metric-value">{{ ownOfficeSummary().approvedCount }}</span>
          </div>
          <div class="metric-box inprogress">
            <span class="metric-label">In-Progress</span>
            <span class="metric-value">{{ ownOfficeSummary().inProgressCount }}</span>
          </div>
          <div class="metric-box completed">
            <span class="metric-label">Completed</span>
            <span class="metric-value">{{ ownOfficeSummary().completedCount }}</span>
          </div>
        </div>

        <div class="footer-stats">
          <div>
            <span class="stat-label">Total Trainees</span>
            <span class="stat-value">{{ ownOfficeSummary().totalTrainees | number }} Attendees</span>
          </div>
          <div>
            <span class="stat-label">Plan Expense</span>
            <span class="stat-value">₹{{ ownOfficeSummary().totalPlanExpense | number:'1.2-2' }}</span>
          </div>
          <div>
            <span class="stat-label">Projected Expense</span>
            <span class="stat-value">₹{{ ownOfficeSummary().totalProjectedExpense | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>
    </fieldset>

    <!-- Sub Office Summary Card -->
    <fieldset>
      <legend>Sub Office Plan Summary</legend>
      <div class="summary-card">
        <div class="summary-card-header">
          <h5 class="summary-card-title sub-dot">
            <span class="dot"></span> All Sub / Child Offices
          </h5>
          <span class="scope-badge sub">Child Offices (District, Block, CLF)</span>
        </div>

        <div class="metrics-grid">
          <div class="metric-box">
            <span class="metric-label">Total Plans</span>
            <span class="metric-value">{{ subOfficeSummary().totalPlans }}</span>
          </div>
          <div class="metric-box approved">
            <span class="metric-label">Approved</span>
            <span class="metric-value">{{ subOfficeSummary().approvedCount }}</span>
          </div>
          <div class="metric-box inprogress">
            <span class="metric-label">In-Progress</span>
            <span class="metric-value">{{ subOfficeSummary().inProgressCount }}</span>
          </div>
          <div class="metric-box completed">
            <span class="metric-label">Completed</span>
            <span class="metric-value">{{ subOfficeSummary().completedCount }}</span>
          </div>
        </div>

        <div class="footer-stats">
          <div>
            <span class="stat-label">Total Trainees</span>
            <span class="stat-value">{{ subOfficeSummary().totalTrainees | number }} Attendees</span>
          </div>
          <div>
            <span class="stat-label">Plan Expense</span>
            <span class="stat-value">₹{{ subOfficeSummary().totalPlanExpense | number:'1.2-2' }}</span>
          </div>
          <div>
            <span class="stat-label">Projected Expense</span>
            <span class="stat-value">₹{{ subOfficeSummary().totalProjectedExpense | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>
    </fieldset>

  </div>

  <!-- Detailed Table Section -->
  <fieldset class="results-panel">
    <legend>Detailed Office-Wise Report</legend>

    <!-- Tab Bar + Toolbar -->
    <div class="results-toolbar">
      <div>
        <p class="results-title">Report Results</p>
        <p class="results-count">
          @if(activeTab() === 'officewise') { {{ officeWiseSummaries().length }} office(s) }
          @if(activeTab() === 'own') { {{ ownOfficePlans().length }} plan(s) }
          @if(activeTab() === 'sub') { {{ subOfficePlans().length }} plan(s) }
        </p>
      </div>

      <div class="tab-nav">
        <button class="tab-btn" [class.active]="activeTab() === 'officewise'" (click)="activeTab.set('officewise')">
          <mat-icon style="font-size:14px;vertical-align:middle;margin-right:3px;">business</mat-icon>
          Office Wise ({{ officeWiseSummaries().length }})
        </button>
        <button class="tab-btn" [class.active]="activeTab() === 'own'" (click)="activeTab.set('own')">
          Own Office Plans ({{ ownOfficePlans().length }})
        </button>
        <button class="tab-btn" [class.active-blue]="activeTab() === 'sub'" (click)="activeTab.set('sub')">
          Sub Office Plans ({{ subOfficePlans().length }})
        </button>
      </div>
    </div>

    <div class="table-shell mt-3">

      <!-- Office-Wise Summary Table -->
      @if(activeTab() === 'officewise') {
      @if(officeWiseSummaries().length === 0) {
      <div class="empty-state">
        <div class="empty-state-title">No office-wise summary records found</div>
        <div class="empty-state-text">No training plans found for the current session hierarchy.</div>
      </div>
      } @else {
      <ag-grid-angular class="hierarchy-summary-grid" [theme]="theme" [rowData]="officeWiseSummaries()"
        [columnDefs]="officeWiseColumnDefs" [defaultColDef]="defaultColDef" />
      }
      }

      <!-- Plan-Wise Items Table (Own / Sub Office) -->
      @if(activeTab() !== 'officewise') {
      @if((activeTab() === 'own' ? ownOfficePlans() : subOfficePlans()).length === 0) {
      <div class="empty-state">
        <div class="empty-state-title">No training plans found</div>
        <div class="empty-state-text">No training plan records found for this scope.</div>
      </div>
      } @else {
      <ag-grid-angular class="hierarchy-summary-grid" [theme]="theme"
        [rowData]="activeTab() === 'own' ? ownOfficePlans() : subOfficePlans()" [columnDefs]="planColumnDefs"
        [defaultColDef]="defaultColDef" />
      }
      }

    </div>
  </fieldset>
  }

</div>